<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import {  ElMessage } from 'element-plus'; // 导入 Element Plus 组件

import axios from 'axios';
import config from '@/config.js'; // 引入配置文件

export default {
  name: "App",
  methods: {
     // 获取配置（标题、Logo、图标）
     async fetchConfig() {
      try {
        const response = await axios.post(`${config.BASE_URL}/pc/api/get_agent_info.php`, {
          agent_host: window.location.origin,
        });
        this.applyConfig(response.data);
      } catch (error) {
        ElMessage.error('配置加载失败');
      }
    },

    // 应用配置数据
    applyConfig(data) {
      if (data.pc_title) document.title = data.pc_title;
      if (data.pc_ico) this.setFavicon(data.pc_ico);
      if (data.pc_logo) this.pclogo = data.pc_logo;
    },

    // 设置浏览器图标
    setFavicon(iconUrl) {
      const link = document.querySelector('link[rel="icon"]') || document.createElement('link');
      link.type = 'image/x-icon';
      link.rel = 'icon';
      link.href = iconUrl;
      document.head.appendChild(link);
    },
  },
  mounted() {
    this.fetchConfig(); // 在组件挂载时调用
  },
};
</script>


<style>
/* 可以在这里放置全局样式 */
body {
  margin: 0;
  font-family: Arial, sans-serif;
}

/* 可选：调整未选中状态的字体大小 */
.el-tabs__item {
  font-size: 14px; /* 未选中时的字体大小 */
  color: #000; /* 默认文字颜色 */
}

/* 全局作用：选中状态 */
.el-tabs__item.is-active {
  color: #ff5c00 !important; /* 选中时的文字颜色 */
  border-bottom: 0px solid #ff5c00 !important; /* 选中时的底部边框颜色 */
  font-weight: bold; /* 选中时的字体加粗 */
  font-size: 14px; /* 选中时的字体大小 */
}

/* 全局作用：悬停状态 */
.el-tabs__item:hover {
  color: #e04b00 !important; /* 悬停时的文字颜色 */
  font-size: 14px; /* 悬停时的字体大小，与选中状态保持一致 */
}

/* 底部激活条颜色 */
.el-tabs__active-bar {
  background-color: #ff5c00 !important; /* 激活条背景颜色 */
}
.v-modal,
.el-overlay {
  /* 让背景有半透明 + 模糊 */
  background-color: rgba(0, 0, 0, 0.3) !important;
  backdrop-filter: blur(10px);
}

/* 调整关闭按钮的大小 */
.el-dialog__headerbtn {
  font-size: 30px !important; /* 调整图标的大小，默认 16px */
  width: 40px !important; /* 按钮宽度 */
  height: 40px !important; /* 按钮高度 */
  top: 10px !important; /* 调整与顶部的距离 */
  right: 10px !important; /* 调整与右侧的距离 */
}

/* 自定义 ElMessageBox 样式 */
.custom-message-box .el-message-box__btns .el-button--primary {
  background-color: #ff5c00; /* 设置确定按钮的背景颜色 */
  border-color: #ff5c00; /* 设置确定按钮的边框颜色 */
  color: #fff; /* 设置确定按钮的文字颜色 */
}

.custom-message-box .el-message-box__btns .el-button--primary:hover {
  background-color: #e64a19; /* 设置确定按钮的悬停背景颜色 */
  border-color: #e64a19; /* 设置确定按钮的悬停边框颜色 */
}
</style>
